import React from 'react'
import { Text, Nav, Box, Footer } from 'grommet'

function SiteFooter(props) {
  const slLogo = 'https://images.squarespace-cdn.com/content/v1/61d5a187b2ab1944309a1189/a4f11595-f467-41b3-b263-c1ec02bf46f7/sl-white.png?format=1500w'
  return (
      <Footer background='navBar' gap="medium">
        <Nav align="center" flex="grow" justify="between" direction="row" pad="xsmall" gap="xsmall">
          <Box align="center" justify="center" direction="row" margin="xsmall">
            {(props.size === 'small') ? <img alt="Sample Logistics Logo" src={slLogo} width='90px' height='37px' /> : <img alt='Sample Logistics Logo' src={slLogo}  width='120px' height='50px' />}
          </Box>
          {(props.size === 'small') ?
          null
          :
          <Box direction='row' gap="medium" justify='center'>
             {/* <Text size="xsmall" textAlign="start" truncate={false}>Home</Text>
            <Text size="xsmall" textAlign="start" truncate={false}>About</Text>
            <Text size="xsmall" textAlign="start" truncate={false}>FAQs</Text>
           <Text size="xsmall" textAlign="start" truncate={false}>Contact</Text> */}
          </Box>
          }
          
          <Text size="small" weight='bold' textAlign="end" margin={{right: 'small'}} truncate={false}>© Sample Logistics 2023</Text>
        </Nav>
      </Footer>
  )
}

export default SiteFooter
